import { apiGet, apiPost, apiPut, apiDelete, unwrap } from './apiClient';
import { ResponseDTO, RoleDTO, PrivilegeDTO } from '@/types/api';

export async function createRole(role: RoleDTO): Promise<string> {
  const res = await apiPost<ResponseDTO<string>>('/api/v1/roles', role);
  return unwrap(res);
}

export async function updateRole(role: RoleDTO): Promise<string> {
  const res = await apiPut<ResponseDTO<string>>('/api/v1/roles', role);
  return unwrap(res);
}

export async function listRoles(excludeGlobal = false): Promise<RoleDTO[]> {
  const res = await apiGet<ResponseDTO<RoleDTO[]>>('/api/v1/roles', {
    params: excludeGlobal ? { excludeGlobal: true } : undefined,
  });
  return unwrap(res);
}

export async function getRoleByName(name: string): Promise<RoleDTO> {
  const res = await apiGet<ResponseDTO<RoleDTO>>('/api/v1/role', { params: { name } });
  return unwrap(res);
}

export async function deleteRole(name: string): Promise<void> {
  await apiDelete<void>('/api/v1/role', undefined, { params: { name } });
}

export async function listPrivileges(): Promise<PrivilegeDTO[]> {
  const res = await apiGet<ResponseDTO<PrivilegeDTO[]>>('/api/v1/privileges');
  return unwrap(res);
}
